import { initSwiper } from '../../components/swiper';
import initAtcPopup from '../../components/atc-popup';
import initProductCardSwatches from '../../components/product-card-swatches';

const initRelatedProducts = () => {
  const relatedProductsEL = document.querySelector('[data-related-products]');
  if (!relatedProductsEL) return;
  const productsUrl = relatedProductsEL.dataset.url;
  if (!productsUrl) return;

  const fetchResults = async (url) => {
    try {
      const response = await fetch(url);
      const html = await response.text();

      // Parse the returned section markup without touching the live DOM
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Find the equivalent panel in the fetched section
      const newPanel = doc.querySelector('[data-related-products]');
      if (!newPanel) return;

      // Replace contents with everything inside the panel:
      // nav buttons + swiper together, dropping only the outer section wrapper
      relatedProductsEL.innerHTML = newPanel.innerHTML;

      // These cards are injected after page load, so they missed the global
      // swatch binding - already-bound cards are skipped, so this only binds new ones.
      initProductCardSwatches();

      // Scope the swiper lookup to the panel we just repopulated
      const sliderEl = relatedProductsEL.querySelector('[data-swiper-related-products]');
      if (!sliderEl) return;

      const relatedProductsSwiper = initSwiper(sliderEl);
      window.theme.swiperObjects.push(relatedProductsSwiper);

      initAtcPopup();

      if (typeof window.ReloadSmartWishlist === 'function') {
        await window.ReloadSmartWishlist();
      }
      if (typeof window.yotpoWidgetsContainer === 'object' && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        await window.yotpoWidgetsContainer.initWidgets();
      }
    } catch (err) {
      console.error('Error fetching filter results:', err);
    }
  };
  fetchResults(productsUrl);
};

export default initRelatedProducts;